// libs
import React, { memo } from 'react';

// svg
import NykaaLogo from 'shared/svg/NykaaLogo';

// styles
import { Container } from './styles';

// defs
interface NFLoaderProps {
  className?: string;
}

function NFLoader({ className = '' }: NFLoaderProps) {
  return (
    <Container className={className} data-test="blob-loader">
      <div className="blobs">
        <div className="blob-center">
          <NykaaLogo className="blog-image" />
        </div>
        <div className="blob" />
        <div className="blob" />
        <div className="blob" />
        <div className="blob" />
        <div className="blob" />
        <div className="blob" />
      </div>
    </Container>
  );
}

export default memo(NFLoader, () => true);
